import { env } from 'configs/EnvironmentConfig';

const tenantId = env.MICROSOFT_TENANT_ID || 'common';

/**
 * Dedicated, lightweight redirect target for the popup flow (served from /public).
 * It does NOT load the React SPA, so no router/guard can strip the `#code=...`
 * fragment before the opener window's MSAL instance reads it.
 */
const MSAL_REDIRECT_PATH = '/auth-redirect.html';

/**
 * Build the redirect URI from the ORIGIN the app is actually served from
 * (localhost in dev, the deployed host in staging/prod). This guarantees the
 * popup returns to the same origin that opened it, so local dev never bounces
 * to the production host. Falls back to env.FRONTEND_URL only if window is
 * unavailable (non-browser contexts).
 */
export const getMsalRedirectUri = () => {
	const base =
		(typeof window !== 'undefined' && window.location.origin) ||
		env.FRONTEND_URL ||
		'';
	if (!base) {
		return undefined;
	}
	return `${base.replace(/\/+$/, '')}${MSAL_REDIRECT_PATH}`;
};

export const msalConfig = {
	auth: {
		clientId: env.MICROSOFT_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${tenantId}`,
		redirectUri: getMsalRedirectUri(),
		// Popup-centric app: keep the main window on the auth screen after sign-in.
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: 'sessionStorage',
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = {
	scopes: ['openid', 'profile', 'email'],
};
